<template>
    <div class="service">
        wallet
    </div>
</template>
<script>
export default {
    data(){
        return{
            
        }
    }
}
</script>
<style lang="scss" scoped>
</style>


// WEBPACK FOOTER //
// src/components/service.vue